(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-creator-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const ATTR = 'data-brand-creator-showcase-bound';
    const VISIBLE_RATIO = 0.35;
    const stateMap = new WeakMap();

    function getState(root) {
      let state = stateMap.get(root);
      if (!state) {
        state = {
          nearView: false,
          inView: false,
          prewarmObserver: null,
          visibleObserver: null,
        };
        stateMap.set(root, state);
      }
      return state;
    }

    function carouselWantsAutoplay(carousel) {
      return Boolean(carousel && carousel.hasAttribute('autoplay') && carousel.getAttribute('autoplay') !== 'false');
    }

    function getActiveSlideIndex(root) {
      const carousel = root.querySelector('x-swiper-carousel');
      if (!carousel || !carousel.swiper || typeof carousel.swiper.activeIndex !== 'number') {
        return 0;
      }

      return carousel.swiper.activeIndex;
    }

    function getPrewarmUrl(url) {
      if (!url) return '';

      try {
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('autoplay', '0');
        return parsed.toString();
      } catch (error) {
        return url.replace('autoplay=1', 'autoplay=0');
      }
    }

    function postEmbedCommand(frame, provider, method) {
      if (!frame || !frame.contentWindow) return;

      if (provider === 'youtube') {
        frame.contentWindow.postMessage(
          JSON.stringify({
            event: 'command',
            func: method === 'play' ? 'playVideo' : 'pauseVideo',
            args: [],
          }),
          '*'
        );
      } else if (provider === 'vimeo') {
        frame.contentWindow.postMessage(
          JSON.stringify({
            method: method === 'play' ? 'play' : 'pause',
          }),
          '*'
        );
      }
    }

    function syncCarouselAutoplay(root, retryCount = 0) {
      const carousel = root.querySelector('x-swiper-carousel');
      const state = getState(root);

      if (!carousel || !carouselWantsAutoplay(carousel)) return;

      if (!carousel.swiper || !carousel.swiper.autoplay) {
        if (retryCount < 20) {
          window.requestAnimationFrame(() => {
            syncCarouselAutoplay(root, retryCount + 1);
          });
        }
        return;
      }

      if (state.nearView) {
        carousel.swiper.autoplay.start();
      } else {
        carousel.swiper.autoplay.stop();
      }
    }

    function syncCarouselMedia(root, activeIndex) {
      const state = getState(root);
      const carousel = root.querySelector('x-swiper-carousel');
      if (!carousel) return;

      carousel.querySelectorAll('.swiper-slide[data-brand-slide-index]').forEach((slide) => {
        const idx = Number(slide.dataset.brandSlideIndex);
        const active = state.inView && idx === activeIndex;
        const prewarm = state.nearView && idx === activeIndex;

        slide.querySelectorAll('video.brand-creator-showcase__native-video').forEach((video) => {
          if (active) {
            const p = video.play();
            if (p && typeof p.catch === 'function') {
              p.catch(() => {});
            }
          } else if (prewarm) {
            video.pause();
            if (video.getAttribute('preload') !== 'auto') {
              video.setAttribute('preload', 'auto');
              video.load();
            }
          } else {
            video.pause();
            if (video.getAttribute('preload') !== 'metadata') {
              video.setAttribute('preload', 'metadata');
            }
          }
        });

        slide.querySelectorAll('iframe[data-brand-creator-embed]').forEach((frame) => {
          const url = frame.getAttribute('data-embed-url');
          if (!url) return;

          const provider = frame.getAttribute('data-embed-provider');
          const prewarmUrl = getPrewarmUrl(url);
          const currentUrl = frame.getAttribute('src');

          if (active) {
            if (!currentUrl) {
              frame.setAttribute('src', prewarmUrl || url);
            }
            postEmbedCommand(frame, provider, 'play');
          } else if (prewarm) {
            if (!currentUrl) {
              frame.setAttribute('src', prewarmUrl || url);
            }
            postEmbedCommand(frame, provider, 'pause');
          } else {
            postEmbedCommand(frame, provider, 'pause');
            frame.removeAttribute('src');
          }
        });
      });
    }

    function updatePlaybackState(root) {
      const activeIndex = getActiveSlideIndex(root);
      syncCarouselMedia(root, activeIndex);
      syncCarouselAutoplay(root);
    }

    function observeVisibility(root) {
      const state = getState(root);

      if (typeof IntersectionObserver === 'undefined') {
        state.nearView = true;
        state.inView = true;
        updatePlaybackState(root);
        return;
      }

      state.prewarmObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target !== root) return;

            const nextNearView = entry.isIntersecting;
            if (state.nearView === nextNearView) return;

            state.nearView = nextNearView;
            updatePlaybackState(root);
          });
        },
        {
          rootMargin: '200px 0px 200px 0px',
          threshold: 0,
        }
      );

      state.visibleObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.target !== root) return;

            const nextInView = entry.isIntersecting && entry.intersectionRatio >= VISIBLE_RATIO;
            if (state.inView === nextInView) return;

            state.inView = nextInView;
            updatePlaybackState(root);
          });
        },
        {
          threshold: [0, VISIBLE_RATIO, 1],
        }
      );

      state.prewarmObserver.observe(root);
      state.visibleObserver.observe(root);
    }

    function bind(root) {
      if (root.getAttribute(ATTR) === 'true') return;
      root.setAttribute(ATTR, 'true');

      const carousel = root.querySelector('x-swiper-carousel');
      if (!carousel) return;

      carousel.addEventListener('swiper:slideChange', (event) => {
        const detail = event.detail || {};
        const index = typeof detail.activeIndex === 'number' ? detail.activeIndex : 0;
        syncCarouselMedia(root, index);
      });

      window.requestAnimationFrame(() => {
        syncCarouselMedia(root, -1);
        syncCarouselAutoplay(root);
      });

      observeVisibility(root);
    }

    function scan(container) {
      const scope = container && container.querySelectorAll ? container : document;
      scope.querySelectorAll('[data-brand-creator-showcase-root]').forEach(bind);
    }

    document.addEventListener('DOMContentLoaded', () => scan(document));
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target && event.target.querySelectorAll) {
        scan(event.target);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["x-nav"] && !Shopify.designMode) return;
  try {
    
  function isMobile(maxWidth) {
    return window.matchMedia(`(max-width: ${maxWidth}px)`).matches;
  }
  document.addEventListener('DOMContentLoaded', function () {
    const tabsBox = document.querySelector('.sticky-tabs-box');
    if (!tabsBox) return;
    var tabs = tabsBox.querySelectorAll('.PageNav');
    var stickyToTop = isMobile(1024) ? 62 : 64;
    var sections = Array.from(tabs).map(function (tab) {
      var href = tab.getAttribute('href');
      if (href && href !== '#') {
        return document.querySelector(href);
      }
    });
    //处理点击事件
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        if (sections[index]) {
          window.scrollTo({
            top: sections[index].offsetTop - stickyToTop, // 偏移粘头高度
            behavior: 'smooth',
          });
        }
      });
    });
    // 处理导航跟随功能（独立的滚动处理）
    function handleNavFollow() {
      // 只有当导航处于sticky状态且可见时才处理导航跟随
      if (!isSticky || !header.classList.contains('show')) return;
      
      var scrollY = window.scrollY;
      sections.forEach(function (section, index) {
        if (!section) return;
        var sectionTop = section.offsetTop - stickyToTop - 30; // 偏移粘头高度
        var sectionHeight = section.offsetHeight;
        var tab = tabs[index];
        // 导航跟随滚动start
        const tabWidth = tab.offsetWidth;
        const tabLeft = tab.offsetLeft;
        const tabRight = tabLeft + tabWidth + 50;
        const tabContainerWidth = tabsBox.offsetWidth;
        const tabContainerScrollLeft = tabsBox.scrollLeft;
        const tabContainerScrollRight = tabContainerScrollLeft + tabContainerWidth;
        // 导航跟随滚动end
        if (section.style.display !== 'none') {
          if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
            tab.classList.add('tm-active');
            // 导航跟随滚动start
            if (tabLeft < tabContainerScrollLeft) {
              tabsBox.scrollTo({
                left: tabLeft - 100,
                behavior: 'smooth',
              });
            } else if (tabRight > tabContainerScrollRight) {
              tabsBox.scrollTo({
                left: tabRight - tabContainerWidth,
                behavior: 'smooth',
              });
            }
            // 导航跟随滚动end
          } else {
            tab.classList.remove('tm-active');
          }
        } else {
          tab.classList.remove('tm-active');
        }
      });
    }
    // Sticky 导航栏功能
    const header = document.getElementById('stickyHeader');
    if (!header) return;
    let isSticky = false;
    let originalPosition = null;
    
    // 延迟获取原始位置，确保页面完全加载
    function getOriginalPosition() {
      if (header) {
        // 临时显示元素以获取正确位置
        header.classList.remove('show');
        header.style.display = 'block';
        header.style.position = 'static';
        header.style.visibility = 'visible';
        header.style.transform = 'none';
        
        originalPosition = header.getBoundingClientRect().top + window.scrollY;
        // console.log('📍 导航原始位置:', originalPosition, 'px');
        
        // 恢复隐藏状态
        header.style.display = 'none';
        header.style.position = '';
        header.style.visibility = '';
        header.style.transform = '';
      }
    }
    
    // 多次尝试获取原始位置，确保成功
    setTimeout(getOriginalPosition, 100);
    setTimeout(getOriginalPosition, 500);
    window.addEventListener('load', getOriginalPosition);
    
    // 也可以通过滚动触发重新获取（防护措施）
    let positionRetryCount = 0;
    function ensurePositionObtained() {
      if (originalPosition === null && positionRetryCount < 5) {
        // console.log('🔄 重试获取导航原始位置...', positionRetryCount + 1);
        getOriginalPosition();
        positionRetryCount++;
        setTimeout(ensurePositionObtained, 1000);
      }
    }
    setTimeout(ensurePositionObtained, 1000);
    
    // 测试函数：手动显示导航（UIKit风格）
    window.testShowNav = function() {
      // console.log('🧪 测试强制显示导航 (UIKit风格)');
      header.classList.add('show');
      header.style.setProperty('transform', 'translateY(0)', 'important');
      header.style.setProperty('opacity', '1', 'important');
      header.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
      // console.log('✅ 导航已强制显示，请检查页面顶部');
      
      // 检查状态
      setTimeout(() => {
        const rect = header.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(header);
        // console.log('🔍 强制显示后的元素状态:');
        // console.log('  - 位置:', { top: rect.top, left: rect.left, width: rect.width, height: rect.height });
        // console.log('  - display:', computedStyle.display);
        // console.log('  - position:', computedStyle.position);
        // console.log('  - z-index:', computedStyle.zIndex);
      }, 100);
    };
    
    function handleScroll() {
      if (originalPosition === null) {
        // console.warn('⚠️ 原始位置还未获取到，跳过处理');
        return;
      }
      
      const scrollY = window.scrollY;
     
      const scrollThreshold = originalPosition;
      const shouldBeSticky = scrollY > scrollThreshold;
      
      // 调试信息（可以在控制台查看）
      if (Math.abs(scrollY - scrollThreshold) < 150) {
        // console.log(`🔍 滚动位置: ${scrollY}px, 阈值: ${scrollThreshold}px (原始位置${originalPosition}+200), 应该显示: ${shouldBeSticky}, 当前显示: ${isSticky}`);
      }
      
      if (shouldBeSticky && !isSticky) {
        // 进入 sticky 状态 - 执行UIKit风格的slide-top动画
        isSticky = true;
        
        // 显示导航并执行UIKit风格的slide-top动画
        // console.log('🔥 显示导航，执行UIKit slide-top动画');
        
        // 1. 先显示元素并设置为fixed定位
        header.classList.add('show');
        header.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
        
        // 2. 设置初始状态（UIKit风格：透明 + 位置在上方）
        header.style.setProperty('transform', 'translateY(-100%)', 'important');
        header.style.setProperty('opacity', '0', 'important');
        
        // console.log('✅ 开始UIKit动画 (0.5s slide-top)');
        
        // 3. 执行UIKit uk-animation-slide-top
        requestAnimationFrame(() => {
          header.classList.add('animate-slideTop');
          
          // UIKit动画完成后清理 (0.5s)
          setTimeout(() => {
            header.classList.remove('animate-slideTop');
            // 确保最终状态正确
            header.style.setProperty('transform', 'translateY(0)', 'important');
            header.style.setProperty('opacity', '1', 'important');
            // console.log('✅ UIKit动画完成，导航已固定在顶部');
            
            // 检查元素实际状态
            const rect = header.getBoundingClientRect();
            const computedStyle = window.getComputedStyle(header);
            // console.log('🔍 元素检查:');
            // console.log('  - 位置:', { top: rect.top, left: rect.left, width: rect.width, height: rect.height });
            // console.log('  - display:', computedStyle.display);
            // console.log('  - position:', computedStyle.position);
            // console.log('  - visibility:', computedStyle.visibility);
            // console.log('  - opacity:', computedStyle.opacity);
            // console.log('  - z-index:', computedStyle.zIndex);
            // console.log('  - transform:', computedStyle.transform);
            // console.log('  - classList:', Array.from(header.classList));
          }, 500);
        });
        
      } else if (!shouldBeSticky && isSticky) {
        // 退出 sticky 状态 - UIKit风格滑出
        // console.log('🔥 开始UIKit退出动画 (0.3s slide-out)');
        isSticky = false;
        
        header.classList.remove('animate-slideTop');
        header.classList.add('animate-slideOut');
        
        // UIKit退出动画完成后清理 (0.3s)
        setTimeout(() => {
          if (!isSticky) { // 双重检查确保状态一致
            header.classList.remove('show', 'animate-slideOut');
            header.style.boxShadow = 'none';
            header.style.setProperty('transform', '', '');
            header.style.setProperty('opacity', '', '');
            // console.log('✅ UIKit退出完成，导航已隐藏');
          }
        }, 300);
      }
    }
    
    // 统一的滚动处理函数
    function handleAllScroll() {
      handleScroll(); // 处理sticky显示/隐藏
      handleNavFollow(); // 处理导航跟随
    }
    
    // 使用 requestAnimationFrame 进行优化的滚动处理
    let ticking = false;
    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleAllScroll();
          ticking = false;
        });
        ticking = true;
      }
    }
    
    window.addEventListener('scroll', requestTick, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
